import { render } from "./score-log-list.vue?vue&type=template&id=fca45c4c&scoped=true&ts=true"
import script from "./score-log-list.vue?vue&type=script&lang=ts"
export * from "./score-log-list.vue?vue&type=script&lang=ts"

import "./score-log-list.vue?vue&type=style&index=0&id=fca45c4c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fca45c4c"]])

export default __exports__